import { useQuery } from '@tanstack/react-query';
import useHttpClient from './useHttpClient';
import { getOrgId } from '../fvid-auth/userSession';

interface ICode {
  description: string;
  code: string;
}

export interface IBillingCodes {
  id: number;
  name: string;
  fieldSelectorName: string;
  position: number;
  isRequired: boolean;
  assignedToBillingTypes: string[];
  codes?: ICode[];
}

/**
 * TanStack Query version of useQueryBillingCodes
 * Fetches billing codes using HTTP client
 */
const useQueryBillingCodes = () => {
  const httpClient = useHttpClient();
  const orgId = getOrgId();

  return useQuery<IBillingCodes[]>({
    queryKey: ['billingCodes', orgId],
    queryFn: async () => {
      const response = await httpClient.get('/billing/availablebillingcodes');
      return response.data.billingCodes || response.data;
    },
    enabled: !!orgId, // Only fetch when orgId is available
  });
};

export default useQueryBillingCodes;
